import React from 'react';
import { View, FlatList } from 'react-native';

import { styles } from '../../constants/styles';

import { Utils, OPComponent, Navigation, ArrowButton, I18n, IconButton } from '../components';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getSortedCasesArray } from '../../selectors/entities';
import { openCaseInfo } from './actions';

class CaseList extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    Utils.trackScreen('Cases', 'Cases List');
  }

  handleSelect = (caseObj) => {
    Utils.trackEvent('Action', 'Select', 'Case Info', caseObj.caseId);

    this.props.actions.openCaseInfo(caseObj.caseId);
    Navigation.push(
      {
        screen: 'CaseInfo',
      },
      this.props.componentId
    );
  };

  newCase = () => {
    Navigation.push(
      {
        screen: 'CaseForm',
        title: I18n.ac('case.newCase'),
      },
      this.props.componentId
    );
  };

  renderItem = ({ item }) => {
    return (
      <ArrowButton
        value={item.name}
        noTopBorder={true}
        onPress={() => {
          this.handleSelect(item);
        }}
      />
    );
  };

  render() {
    return (
      <View style={styles.container}>
        <IconButton
          label={I18n.t('case.addCase')}
          hideArrow={true}
          noTopBorder={true}
          imageSource={require('../../../resources/icon-add-user.png')}
          onPress={this.newCase}
        />
        <FlatList
          data={this.props.cases}
          renderItem={this.renderItem}
          keyExtractor={(item) => `${item.caseId}`}
        />
      </View>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    cases: getSortedCasesArray(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ openCaseInfo }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseList);
